<template>
    <input
        type="text"
        inputmode="numeric"
        :value="draft"
        :disabled="loading"
        :aria-label="label"
        :style="{ '--page-input-digits': pageInputDigits }"
        @input="onInput"
        @keydown.enter.prevent="commit"
        @keydown.esc.prevent="cancel"
        @blur="commit"
    />
</template>

<script>
export default {
    name: 'PageInput',
    props: {
        activePage: { type: Number, required: true },
        totalPages: { type: Number, required: true },
        loading: { type: Boolean, default: false },
        label: { type: String, required: true },
    },
    emits: ['toPage'],
    data() {
        return {
            draft: String(this.activePage),
            dirty: false,
        };
    },
    computed: {
        pageInputDigits() {
            return Math.max(2, String(this.totalPages).length);
        },
    },
    watch: {
        activePage() {
            this.reset();
        },
    },
    methods: {
        reset() {
            this.draft = String(this.activePage);
            this.dirty = false;
        },
        onInput(event) {
            this.draft = event.target.value.replace(/\D/g, '');
            event.target.value = this.draft;
            this.dirty = true;
        },
        commit() {
            if (!this.dirty) return;
            if (this.loading || !this.draft || this.totalPages < 1) {
                this.reset();
                return;
            }

            const page = Math.min(this.totalPages, Math.max(1, Number(this.draft)));
            this.draft = String(page);
            // The store may update later; a following blur must not navigate again.
            this.dirty = false;
            if (page !== this.activePage) this.$emit('toPage', page);
        },
        cancel(event) {
            this.reset();
            event.target.blur();
        },
    },
};
</script>
